import { Button, DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierList extends Layout {
    btnAddCarrier: Button;
    btnInviteCarrier: Button;
    layoutheaderCarrierList: LayoutHeader;
    sourceCarrier: DataSource;
    table1: Table;
}
